<ng-container *ngIf="record$ | async as record">
    <med-media-player *ngIf="record.isPlayableMedia(); else imagePreview" [record]="record"></med-media-player>

    <ng-template #imagePreview>
        <sh-image-viewer
            [imageSources]="[recordPreviewUrl$ | async]"
            [rotate]="'true'"
            [actionsPosition]="ViewerActionsPosition.BOTTOM_EXTERNAL"
            [fillSpace]="true"
            [customActionItems]="customActionItems"
            [fullscreen]="false"
            [allowTransform]="allowTransform$ | async"
            style="height: 100%"
        ></sh-image-viewer>
    </ng-template>
</ng-container>
